import(/* webpackMode: "eager" */ "/home/clp/htdocs/mcjfe-app/src/app/admin/page.tsx");
